export const AllTransitions = {
    FADE: 'fade',
    FADE_UP: 'fade-up',
    FADE_DOWN: 'fade-down',
    FADE_LEFT: 'fade-left',
    FADE_RIGHT: 'fade-right',
    UP: 'up',
    DOWN: 'down',
    LEFT: 'left',
    RIGHT: 'right',
};

export const APP_TRANSITIONS = [
    AllTransitions.FADE,
    AllTransitions.FADE_UP,
    AllTransitions.FADE_DOWN,
    AllTransitions.FADE_LEFT,
    AllTransitions.FADE_RIGHT,
    AllTransitions.UP,
    AllTransitions.DOWN,
    AllTransitions.LEFT,
    AllTransitions.RIGHT,
];
